import React, { useCallback } from 'react';
import './styles.scss';

const OptimizedInput = ({
    id,
    name,
    label,
    type = 'text',
    value = '',
    onChange,
    placeholder = '',
    isDisabled = false,
    maxLength,
    className = '',
    ...props
}) => {
    const handleChange = useCallback((e) => {
        if (isDisabled) return;
        
        if (onChange) {
            onChange(e);
        }
    }, [isDisabled, onChange]);

    return (
        <div className={`optimized-input ${className}`}>
            {label && <label htmlFor={id}>{label}</label>}
            <input
                id={id}
                name={name || id}
                type={type}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={isDisabled}
                maxLength={maxLength}
                className="optimized-input-field"
                autoComplete="off"
                {...props}
            />
        </div>
    );
};

export default OptimizedInput;
